import React from "react";
import About from "./About";
import Navbar from "./Navbar";
import Skills from "./Skills";
import styles from "./Home.module.css";
import Projects from "./Projects";
import blob1 from "../Atributes/blobanimation.svg";
import Footer from "./Footer";
import githublogo from "../Atributes/githubicon.svg";
import linkedinlogo2 from "../Atributes/linkedinlogo2.svg";
import myimage from "../Atributes/myimage.jpg"

const Home = () => {
  return (
    <div>
      <Navbar />
      <div id="home">
        <div className={styles.upperpart}>
          <div className={styles.left}>
            <h1 className={styles.nameheading}>Hi 👋,</h1>
            <h1 className={styles.nameheading}>
              I'am <span style={{ color: "royalblue" }}>Narayan</span>
            </h1>
            <h1 className={styles.nameheading}>MERN Developer</h1>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "40px",
                gap: "20px",
              }}
            >
              <a href="https://github.com/Narayan-Chatalwar" target="_blank">
                <img src={githublogo} alt="" width="40px" />
              </a>
              <a
                href="https://linkedin.com/in/narayan-chatalwar-09905121a"
                target="_blank"
              >
                <img src={linkedinlogo2} alt="" width="40px" />
              </a>
            </div>
            <div>
              <a
                target="_blank"
                href="https://drive.google.com/file/d/1sSM8PgUJaRW1KcvQ4GhI2vZR6I1ro76n/view?usp=sharing"
              >
                <button className={styles.buttonresume}>Resume</button>
              </a>
            </div>
          </div>

          <div className={styles.right}>
            <a href="" target="_target">
              <img src={blob1} alt="" className={styles.blob1} />
            </a>
            <img className={styles.myimage} src={myimage} alt="" />
          </div>
        </div>
      </div>

      <About />
      <Skills />
      <Projects />
      <Footer />
    </div>
  );
};

export default Home;
